module.exports = __webpack_public_path__ + "img/opened-game-background.1b792aa9.webp";